import React from 'react';

import { CheckboxFieldIcon } from 'src/components/icons/CheckboxFieldIcon';
import { DateFieldIcon } from 'src/components/icons/DateFieldIcon';
import { DropdownFieldIcon } from 'src/components/icons/DropdownFieldIcon';
import { IinBoxIcon } from 'src/components/icons/IinBoxIcon';
import { NumberIcon } from 'src/components/icons/NumberIcon';
import { RadioButtonIcon } from 'src/components/icons/RadioButtonIcon';
import { SignatureFieldIcon } from 'src/components/icons/SignatureFieldIcon';
import { Apollo } from 'src/gql/generated';

const FIELD_VARIANT_ICONS = {
  [Apollo.FieldVariant.Checkbox]: CheckboxFieldIcon,
  [Apollo.FieldVariant.Date]: DateFieldIcon,
  [Apollo.FieldVariant.Dropdown]: DropdownFieldIcon,
  [Apollo.FieldVariant.Number]: NumberIcon,
  [Apollo.FieldVariant.Radiobutton]: RadioButtonIcon,
  [Apollo.FieldVariant.Signature]: SignatureFieldIcon,
  [Apollo.FieldVariant.Text]: IinBoxIcon,
} satisfies Record<Apollo.FieldVariant, React.ElementType>;

export function FieldIcon(props: { fieldVariant: Apollo.FieldVariant; className?: string }) {
  const { className, fieldVariant } = props;
  const Icon = FIELD_VARIANT_ICONS[fieldVariant];

  return <Icon className={className} />;
}
